'use client';
import React, { memo } from 'react';
import useApplyLogging from '../../hooks/useApplyLogging.mjs';

function IcTxtDepthCategoryMyAsset(customProps) {
  const {
    fill,
    ...props
  } = customProps;
  useApplyLogging('ICON_IcTxtDepthCategoryMyAsset');
  return /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 46 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.05 8.43011V3.36011H11.91V17.3701H10.05V10.1701H8.655V17.0401H6.84V3.58511H8.655V8.43011H10.05ZM1.95 13.3951H2.49C3.435 13.3951 4.53 13.3351 5.835 13.1551L6.015 14.8351C4.71 15.0901 3.555 15.1501 2.25 15.1501H0V4.32011H1.95V13.3951Z",
    fill: fill || '#1E1E23'
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8043 8.43011H30.8293V10.1701H28.8043V17.3701H26.8993V3.36011H28.8043V8.43011ZM22.3693 6.15011V6.55511C22.3693 7.54511 22.2643 8.47511 22.0393 9.39011L25.8193 14.1151L24.3793 15.3601L21.2893 11.5051C20.6443 12.9001 19.7143 14.2201 18.4843 15.4951L17.1193 14.2501C19.3693 11.8351 20.4943 9.54011 20.4943 6.55511V6.15011H17.6743V4.39511H25.2793V6.15011H22.3693Z",
    fill: fill || '#1E1E23'
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.028 3.36011V6.67511H45.053V8.41511H43.028V13.7251H41.108V3.36011H43.028ZM38.903 11.5651L35.513 8.92511C34.823 9.99011 33.818 10.9501 32.468 11.8501L31.373 10.3801C33.848 8.73011 34.778 6.97511 34.778 4.95011V3.85511H36.653V4.95011C36.653 5.77511 36.533 6.54011 36.308 7.26011L39.998 10.1401L38.903 11.5651ZM33.818 12.8401H35.723V15.6301H43.688V17.3701H33.818V12.8401Z",
    fill: fill || '#1E1E23'
  }));
}
var IcTxtDepthCategoryMyAsset$1 = /*#__PURE__*/memo(IcTxtDepthCategoryMyAsset);

export { IcTxtDepthCategoryMyAsset$1 as default };
